module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table":{"placeholder":"There\u0027s no data that has been edited yet.","headers":{"section":"Section","before":"Before","after":"After","actionBy":"Action By","date":"Date"}}}}')
  delete Component.options._Ctor
}
